import { AppState } from '@guildeducationinc/guild-auth';
import { basename } from '@src/utilities/urlUtility';

/**
 * Utility for Auth0 redirect callback handler.
 *
 * @example
 * ```jsx
 * import { authRedirectCallback } from '@src/utilities';
 *
 * <AuthProvider
 *   onRedirectCallback={appState => {
 *     authRedirectCallback(appState, history);
 *   }}
 *   {...otherProps}
 * >
 *   {children}
 * </AuthProvider>
 * ```
 *
 * @remarks
 * - 'appState' is provided by the AuthProvider and must be passed into this utility
 * - 'history' refers to the history object provided by invoking useHistory() from 'react-router-dom'
 *
 * @packageDocumentation
 */

interface History {
  location: { pathname: string };
  push: (target: string) => void;
}

export const authRedirectCallback = (appState: AppState = {}, history: History) => {
  window.history.replaceState({}, document.title, window.location.pathname);
  if (appState?.targetUrl && appState.targetUrl !== history.location.pathname) {
    // remove basename from targetUrl if present
    const target = appState.targetUrl.replace(basename, '');
    history.push(target);
  }
};
